import React, { Component } from 'react';
import './Homepage.scss';
import App from '../App';
import { Link } from 'react-router-dom'
import Card from '../components/Card/Card';
import Icon from '../components/Icon/Icon';
import ICONS from '../components/Icon/IconPaths';
import LogoText from '../components/Icon/LogoText';
import iphone from '../assets/img/iPhone-X.png';
import statusbar from '../assets/img/Statusbar.png';
import homeIndicator from '../assets/img/Home-Indicator.png';

class Homepage extends Component {

  render() {
    return (
      <div>
        <div className="Header d-flex m-4 justify-content-between align-items-center">
          <div className=" d-none d-sm-block">
            <LogoText className="Icon --Green-base d-none d-sm-block" />
          </div>
          <div className=" d-flex d-sm-none">
            <Icon icon={ICONS.LOGO} size="48" viewbox="64" className="Icon --Green-base" />
          </div>
          <Link to="/"><button className="btn --Standard --Green-base">Sign in</button></Link>
        </div>
        <div className="Hero">
          <div className="maxWidth-1120 m-auto px-3 px-sm-5">
            <div className="hero-cols">
              <div className="hero-col-1">
                <h1 className="display-1 mt-0 mb-3">Informazione intelligente</h1>
                <p className="mb-4">Ogni mattina l'informazione imparziale e di qualità: solo le notizie che contano, direttamente nella tua email e via App.</p>
                <form className="hero-form">
                  <div className="d-block d-sm-flex">
                    <input placeholder="Nome" type="text" className="mr-0 mr-sm-2"/>
                    <input placeholder="Cognome" type="text" className="ml-0 ml-sm-2"/>
                  </div>
                  <input placeholder="Email" className="mb-3"></input>
                  <div className="d-block d-sm-flex align-items-center text-center text-sm-left">
                  <Link to="/"><button className="btn --Standard --Green-base w-100 w-sm-auto">Prova gratuita</button></Link>
                    <p className="caption my-sm-0 ml-sm-3">Hai un coupon? <Link to="/">Attivalo qui</Link></p>
                  </div>
                </form>
              </div>
              <div className="hero-col-2">
                <div className="app-wrapper">
                  <img src={iphone} className="iphone" />
                  <img src={statusbar} className="statusbar" />
                  <img src={homeIndicator} className="home-indicator" />
                  <iframe width="375" height="778" src="https://master.d2f3n38eq2zajn.amplifyapp.com/" frameborder="0" allowfullscreen></iframe>

                </div>

              </div>
            </div>
          </div>
        </div>
        <div className="Description">
          <div className="description-overlay">
            <div className="maxWidth-1120 m-auto px-3 px-sm-5">
              <h1 className="--White m-0">Siamo puntuali ogni mattino, 365 giorni all’anno, un daily briefing essenziale per iniziare la giornata.</h1>
              {/*<div className="description-cols">
                  <div>
                    <h5 className="--White mb-3">Sempre informato</h5>
                    <p className="--White">Essere informati non è sempre facile. Noi lavoriamo per questo.</p>
                  </div>
                  <div>
                    <h5 className="--White mb-3">Conosci il mondo</h5>
                    <p className="--White">Scegliamo per te, con cura, le notizie che contano davvero.</p>
                  </div>
                  <div>
                    <h5 className="--White mb-3">Risparmia tempo</h5>
                    <p className="--White">In pochi minuti puoi capire la giornata. E poi puoi approfondire.</p>
                  </div>
                </div>*/}
            </div>
          </div>
        </div>
        <div className="Pricing">
          <div className="maxWidth-1120 m-auto px-3 px-sm-5">
            <h1 className="mt-0">I nostri prezzi sono imbattibili</h1>
            <p className="mb-5">Con pochi centesimi al giorno, puoi essere informato in modo semplice. Qualità, senza chiacchiere.</p>
            <div className="pricing-cols">
              <Card className="p-5 --Shadow">
                <h5 className="mt-0 mb-3">Monthly</h5>
                <p>30 day free trial, then <b>2,99€</b> billed every month</p>
                <Link to="/"><button className="btn --Standard --Green-base">Prova gratuita</button></Link>
              </Card>
              <Card className="p-5 --Shadow">
                <h5 className="mt-0 mb-3">Annual</h5>
                <p>30 day fee trial, then <b>29,99€</b> billed once a year</p>
                <Link to="/"><button className="btn --Standard --Green-base">Prova gratuita</button></Link>
              </Card>
              <Card className="p-5 --Shadow">
                <h5 className="mt-0 mb-3">Lifetime</h5>
                <p>One time payment of <b>79.99€</b></p>
                <Link to="/"><button className="btn --Standard --Green-base">Prova gratuita</button></Link>
              </Card>
            </div>
          </div>
        </div>
        <div className="Footer">
          <div className="maxWidth-1120 m-auto px-3 px-sm-5">
            <div className="footer-cols">
              <div className="mb-5 mb-sm-0">
                <LogoText className="Icon --White" />
                {/*<Icon icon={ICONS.LOGO} size="48" viewbox="64" className="Icon --White" />*/}
                <div className="mb-5"></div>
               </div>
              <div className="text-sm-right">
                <Link to="/"><h5 className="--White mt-0">Terms &amp; Conditions</h5></Link>
                <Link to="/"><h5 className="--White">Privacy Policy</h5></Link>
                <Link to="/"><h5 className="--White mb-5">Contact us</h5></Link>
                <a href="https://www.twitter.com/goodmorningit" target="_blank"><Icon icon={ICONS.TWITTER} className="Icon --White" /></a>
                <a href="https://www.facebook.com/goodmorningit" target="_blank" className="ml-4"><Icon icon={ICONS.FACEBOOK} className="Icon --White" /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Homepage;
